import { CHECK_SITE_INSTALLED } from "@/gql/analytics";
import { QueryHookOptions, useQuery } from "@apollo/client";
import {
  ICheckSiteInstalledQuery,
  ICheckSiteInstalledQueryVariables,
} from "@shared/common/types/api-private/generated/graphql";

const useSiteInstalled = ({
  sitePublicIds,
  options,
}: {
  sitePublicIds: string[];
  options?: Omit<
    QueryHookOptions<
      ICheckSiteInstalledQuery,
      ICheckSiteInstalledQueryVariables
    >,
    "variables"
  >;
}) => {
  return useQuery<ICheckSiteInstalledQuery, ICheckSiteInstalledQueryVariables>(
    CHECK_SITE_INSTALLED,
    {
      variables: { sitePublicIds },
      skip: sitePublicIds.length === 0,
      ...options,
    }
  );
};

export default useSiteInstalled;
